// extracted by mini-css-extract-plugin
module.exports = {"bullets":"bullets-module--bullets--3kq3z","bullet":"bullets-module--bullet--1uCAl","activeBullet":"bullets-module--active-bullet--trIwX"};